import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Badge from './Badge';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as localStorage from '../../../localStorage/localStorage';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as animationHelper from "../../../helpers/animationHelper";

class BadgeDashboard extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            badgeUserData: this.props.badgeUserData,
            badges: localStorage.contentData.experience.badges,
            showAchievedCount: true,
            showAchievedState: true,
            currentBadgeLocale: {},
            currentBadgeId: 0,
            lang: this.props.lang,
            your_badges_label: appHelper.getLocaleString("your_badges_label")
        };

        this.getUserBadge = this.getUserBadge.bind(this);
        this.showDetails = this.showDetails.bind(this);
        this.show = this.show.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);

        this.badgeRef = React.createRef();
    }

    componentDidMount() {
        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.badgeUserData !== nextProps.badgeUserData) {
            this.setState({badgeUserData: Object.assign([], nextProps.badgeUserData)});
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                your_badges_label: appHelper.getLocaleString("your_badges_label")
            });
        }
    }

    getUserBadge(badge) {
        return appHelper.getArrayObjectByKey(this.state.badgeUserData, "badge_id", badge.badge_id);
    }

    show() {
        let badgeRef = this.badgeRef.current;
        if(appHelper.isObjectEleDefined(badgeRef)) {
            let params = {
                ele: badgeRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0,
                callback: null
            };
            animationHelper.showHeight(params);
        }
    }

    showDetails(badge_id, locale) {
        this.setState({
            currentBadgeLocale: Object.assign({}, locale),
            currentBadgeId: parseFloat(badge_id)
        });
    }


    setKeyboardAccessibility() {

    }

    render() {
        return (
            <div className="a-c" ref={this.badgeRef}>
                <div className={`object-container`} style={{marginBottom: 0}}>
                    <div className={`badge-dashboard`}>
                        <h4 className={`${objectConstants.DEFAULT_HEADING_CLASS} text-center`}>{this.state.your_badges_label}</h4>
                        <ul className="badge-grid" role="presentation">
                            {this.state.badges.map(badge =>
                                <li key={badge.badge_id} className="badge-grid-item">
                                    <Badge badge={badge}
                                           userBadge={this.getUserBadge(badge)}
                                           showAchievedCount={this.state.showAchievedCount}
                                           showAchievedState={this.state.showAchievedState}
                                           onClicked={this.showDetails}
                                           currentBadgeId={parseFloat(this.state.currentBadgeId)}
                                    />
                                </li>
                            )}
                        </ul>
                        {
                            typeof this.state.currentBadgeId === "number" && this.state.currentBadgeId !== 0 && !isNaN(this.state.currentBadgeId)
                                ?
                                <div className={`badge-details`} role="presentation">
                                    <p><strong>{this.state.currentBadgeLocale.long_title}</strong></p>
                                    <div className="content"
                                         dangerouslySetInnerHTML={{__html: this.state.currentBadgeLocale.description}}/>
                                </div>
                                :
                                null
                        }
                    </div>
                </div>
            </div>
        );
    }
}


BadgeDashboard.propTypes = {
    badgeUserData: PropTypes.array,
    actions: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    bite_id: PropTypes.number
};

BadgeDashboard.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        badgeUserData: state.userData.badges
        //badgeUserData: appHelper.getArrayObjectByKey(state.userData.bites,"bite_id",ownProps.bite_id).badges
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BadgeDashboard);



/** WEBPACK FOOTER **
 ** ./src/components/objects/badges/BadgeDashboard.js
 **/